namespace GeniuzPOS.Purchase {
    export class PoSupplierColumns {
        static columnsKey = 'Purchase.PoSupplier';
    }
}
